import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import user from 'js/lib/user';

import type {
  CustomLabelsV2ByUserAndCourseQuery,
  CustomLabelsV2ByUserAndCourseQueryVariables,
} from 'bundles/custom-labels/hoc/__generated__/CustomLabelsV2';
import { useCustomLabelsMapping } from 'bundles/custom-labels/hooks/useCustomLabelsMapping';
import type { CustomLabels, ReplaceCustomContent } from 'bundles/custom-labels/types/CustomLabels';

/* eslint-disable graphql/template-strings */
export const CustomLabelsQuery = gql`
  query CustomLabelsQuery($userId: String!, $courseId: String!) {
    CustomLabelsV2 @naptime {
      byUserAndCourse(userId: $userId, courseId: $courseId) {
        elements {
          id
          moduleNames
          isRhyme
          namings {
            courseraCourse
            courseraWeek
          }
        }
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */

export type OutputProps = {
  loading: boolean;
  error: Error | undefined;
  customLabels?: CustomLabels;
  replaceCustomContent: ReplaceCustomContent;
};

const useCustomLabelsByUserAndCourse = (courseId: string): OutputProps => {
  const userId = user.get().id.toString();
  const { loading, data, error } = useQuery<
    CustomLabelsV2ByUserAndCourseQuery,
    CustomLabelsV2ByUserAndCourseQueryVariables
  >(CustomLabelsQuery, {
    variables: {
      courseId,
      userId,
    },
    skip: !courseId || !userId,
    ssr: false,
  });

  const customLabels = data?.CustomLabelsV2?.byUserAndCourse?.elements?.[0];
  const { replaceCustomContent } = useCustomLabelsMapping(courseId, customLabels);

  return {
    loading,
    error,
    customLabels,
    replaceCustomContent,
  };
};

export default useCustomLabelsByUserAndCourse;
